import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8deb9ccd66ffb00/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8deb9ccd66ffb00/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionsGrid"] */ "/tmp/8deb9ccd66ffb00/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/app/[locale]/integrations/[slug]/integration.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/node_modules/next/dist/client/link.js");
